import store from '../store/store.js';
import { clearAuthorization } from '../actions/authorization-actions.js';

export const logout = () => {
  store.dispatch(clearAuthorization());
  window.location.replace('/login');
};



// WEBPACK FOOTER //
// ./src/utils/logout.js